import { useStore } from "../../app/stores/StoreContext";

export function useFormatDate() {
  const { userStore } = useStore();

  return (date: Date, overrideOptions?: Intl.DateTimeFormatOptions) => {
    const options: Intl.DateTimeFormatOptions = {
      dateStyle: "long", // "full" | "long" | "medium" | "short" | undefined,
      timeStyle: "short", // "full" | "long" | "medium" | "short" | undefined
    };

    return new Intl.DateTimeFormat(userStore.currentLanguage.code, overrideOptions ?? options).format(date);
  };
}
